import React, { useState } from "react";
import { Pagination, Button } from "antd";
import CircularProgress from "../../components/CircularProgress";
import { useAuth0 } from "@auth0/auth0-react";
import { usePageQueries } from "./queries";
import _ from "lodash";

import NewsCard from "../../components/Widgets/NewsCard/NewsCard.js";
import Widget from "../../components/Widget/index.js";
import "./styles.css"; // Add a CSS file for styling

const News = () => {
  const { isAuthenticated } = useAuth0();
  const [currentPage, setCurrentPage] = useState(1);

  const { permissionsError, main, pageDataLoading, mainError } = usePageQueries(
    { isAuthenticated }
  );

  const isError = mainError || permissionsError;

  if (pageDataLoading) return <CircularProgress />;
  if (isError) return <div>Sorry an Error occurred</div>;

  const digestContent = (
    <>
      <h3>🛥️ Grandweld Shipyards Delivers Aluminium Patrol Boats</h3>
      <p>
        Grandweld Shipyards has completed delivery of a new series of 38-meter
        aluminium patrol boats from its Dubai Maritime City facility. These
        high-speed vessels are designed for multi-role maritime security,
        reflecting growing regional demand for agile, locally built defense
        platforms. The move reinforces Grandweld’s role as a key player in
        Middle Eastern shipbuilding for the security sector.
      </p>

      <h3>🚢 MSC Expands with 20 More Mega Containerships</h3>
      <p>
        MSC Mediterranean Shipping Company has strengthened its fleet with an
        additional 20 ultra-large containerships, pushing its total order book
        to 74 vessels. Spread across five shipyards in China and valued at
        around $17 billion, this expansion underlines MSC’s aggressive strategy
        to scale capacity and extend its global reach amid shifting trade
        dynamics. It also highlights Asia’s continued dominance in large-scale
        ship construction.
      </p>
    </>
  );

  return (
    <>
      {/* <Widget title="Weekly Digest">
        <h3 className="digest-title">This week in shipbuilding</h3>
        <div className="digest-content">
          {digestContent}
          <Button type="link" href="/weekly-digest">
            Read More
          </Button>
        </div>
      </Widget> */}
      <Pagination
        current={currentPage}
        onChange={(p) => {
          setCurrentPage(p);
        }}
        total={main?.length}
      />
      {main &&
        main
          .filter(
            (news, index) =>
              index >= (currentPage - 1) * 10 && index < currentPage * 10
          )
          .map((news, index) => {
            return <NewsCard news={news} key={`news_${index}`}></NewsCard>;
          })}
      <Pagination
        current={currentPage}
        onChange={(p) => {
          setCurrentPage(p);
        }}
        total={main.length}
      />
    </>
  );
};

export default News;
